var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"seoBoard"},[(_vm.status == 1)?_c('ig-icon',{staticClass:"weikaishi",attrs:{"name":"weikaishi"}}):_vm._e(),(_vm.status == 2)?_c('ig-icon',{staticClass:"fuwuzhong",attrs:{"name":"fuwuzhong"}}):_vm._e(),(_vm.status == 3)?_c('ig-icon',{staticClass:"tingzhi",attrs:{"name":"tingzhi"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }